import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  OrderAdjustmentModel,
  OrderAdjustmentMutationInput,
  OrderAdjustmentMutationVoid,
} from './model';

export function useCreateOrderAdjustment(
  options?: UseMutationOptions<
    ApiResult<OrderAdjustmentModel>,
    ApiError,
    OrderAdjustmentMutationInput
  >,
): UseMutationResult<
  ApiResult<OrderAdjustmentModel>,
  ApiError,
  OrderAdjustmentMutationInput
> {
  return useMutation<
    ApiResult<OrderAdjustmentModel>,
    ApiError,
    OrderAdjustmentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'order-adjustments',
      method: 'POST',
      body,
      classType: OrderAdjustmentModel,
    });
  }, options);
}

export function useVoidOrderAdjustment(
  options?: UseMutationOptions<
    ApiResult<{ message: string }>,
    ApiError,
    OrderAdjustmentMutationVoid
  >,
): UseMutationResult<
  ApiResult<{ message: string }>,
  ApiError,
  OrderAdjustmentMutationVoid
> {
  return useMutation<
    ApiResult<{ message: string }>,
    ApiError,
    OrderAdjustmentMutationVoid
  >(async function (body) {
    return await MutationFetchFunction({
      url: `order-adjustments/${body.id}/void`,
      method: 'PATCH',
    });
  }, options);
}
